import moment from 'moment-timezone';
import { DateFormatConstants } from '../constants';

export class TimeZoneUtil {
  /**
   * Formats a timezone date with a specific timezone
   *
   * @param date
   * @param timeZone
   * @param dateFormat
   */
  static formatTimeZoneDate(date: Date, timeZone: string, dateFormat = DateFormatConstants.DATE_FORMAT_FULL): string {
    return moment.tz(date, timeZone).format(dateFormat.replace('tz', '[' + timeZone + ']'));
  }
}
